module.exports = __webpack_public_path__ + "img/easywords.fef66e46.png";